import { buildLxoMenu } from "routes"
import { cloneMenu } from "./helpers"
// Also available for LX-specific tweaks: overrideByKey, removeByKey, addItems

/**
 * LX role menu — its own module, cloned from the LXO menu.
 *
 * LX currently mirrors LXO exactly. To make LX diverge, edit only this file;
 * because we clone, changes here can never affect the LXO menu. Examples:
 *
 *   const menu = cloneMenu(buildLxoMenu())
 *   return removeByKey(menu, "leave-request")
 *   // or: return overrideByKey(menu, "assistant", { name: "LX Workspace" })
 *
 * Use this file as the template when adding the next role menus.
 */
export const buildLxMenu = () => cloneMenu(buildLxoMenu())
